import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { groundTransportSections } from "groundTransport/groundTransportSections";
import { useGroundTransportDetail } from "groundTransport/useGroundTransportDetail";
import { getGroundFieldMetaData } from "shared/utils/fieldsHelper/groundFields";
import React from "react";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";
import { invalidateGroundTransportsCache } from "utilities/api/groundTransportQuery";
import { useQueryClient } from "@tanstack/react-query";

interface GroundSidePanelDetailsProps {
  groundTransportSidePanelData: server.dto.GroundTransportSidePanelData
  refetch: () => Promise<void>
}

export const GroundSidePanelDetails = (props: GroundSidePanelDetailsProps) => {
  const {
    state,
    hasDriver,
    hasMap,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateGroundTransportInstruction,
  } = useGroundTransportDetail(
    props.groundTransportSidePanelData.groundTransport,
    props.groundTransportSidePanelData.passengers,
  );

  const queryClient = useQueryClient();

  const onSuccessfulUpdateSidePanel = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    await props.refetch();
    invalidateGroundTransportsCache(queryClient);
  }

  const fieldMetaData = getGroundFieldMetaData(site.currentEnvironment, state, props.groundTransportSidePanelData.groundTransport.permissions);

  const [mainSection, ...otherSections] = groundTransportSections(state, fieldMetaData, getUpdateGroundTransportInstruction, hasDriver, hasMap);
  const sections = [{ ...mainSection, hideTitle: true }, ...otherSections];

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.groundTransportSidePanelData.groundTransport.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    sections={sections}
    additionalContent={<>
      <SidePanelLinkedShowList
        linkedShows={props.groundTransportSidePanelData.linkedShows}
        linkShowToTravel={{
          canLink: props.groundTransportSidePanelData.groundTransport.permissions.canModify,
          travelType: "groundTransport",
          travelId: props.groundTransportSidePanelData.groundTransport.groundTransportId,
          appointmentDateTime: props.groundTransportSidePanelData.groundTransport.dateTime,
          artist: props.groundTransportSidePanelData.groundTransport.artist,
          linkedShowIds: props.groundTransportSidePanelData.linkedShows.map(show => show.showId),
          onLinked: props.refetch
        }}
      />
    </>}
  />
}
